<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">
		<!-- <el-button type="success" size="mini" @click="openModel(false)">添加规格</el-button> -->
	
		<div class="mr-auto">
			<el-form inline ref="form" :model="searchform">
          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
          </el-form-item>
					<el-form-item  class="mb-0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd">
						    </el-date-picker>
					</el-form-item>
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
					</el-form-item>
			</el-form>
       
		 
		
			
    		
		</div>
	
	</div>

  <el-table
      :data="tableData"
       v-loading="loading"
      style="width: 100%"
      border class="mt-2"  :empty-text="$t('tableText.데이타가없습니다')"
      show-summary
       :summary-method="getSummaries">


       <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt1)}}</template>
      </el-table-column>
     
      <el-table-column
        
        :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt2)}}</template>
      </el-table-column>

       <el-table-column
        
        :label="$t('msg.충환')" prop="tt12" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt12)}}</template>
      </el-table-column>


       <el-table-column 
        :label="$t('msg.총배팅')" prop="tt5" align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.tt5)}}</span></template>
      </el-table-column>

      <el-table-column 
        :label="$t('msg.총배팅카')" prop="tt5ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5ca)}}</template>
      </el-table-column>
      <el-table-column 
         :label="$t('msg.총배팅슬')" prop="tt5st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5st)}}</template>
      </el-table-column>
    
      <el-table-column 
        :label="$t('msg.총배팅파')" v-if="this.power=='1'" prop="tt5pa" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5pa)}}</template>
      </el-table-column>

        <el-table-column
        :label="$t('msg.총당첨')" prop="tt6" align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.tt6)}}</span></template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총당첨카')" prop="tt6ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6ca)}}</template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총당첨슬')" prop="tt6st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6st)}}</template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총당첨파')" v-if="this.power=='1'" prop="tt6pa" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6pa)}}</template>
      </el-table-column>

        <el-table-column
        :label="$t('msg.총수수료')" prop="tt7" align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.tt7)}}</span></template>
      </el-table-column>

      <el-table-column
         :label="$t('msg.총수수료카')"  prop="tt7ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7ca)}}</template>
      </el-table-column>

      <el-table-column
        :label="$t('msg.총수수료슬')"  prop="tt7st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7st)}}</template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총수수료파')" v-if="this.power=='1'" prop="tt7pa" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7pa)}}</template>
      </el-table-column>

       <el-table-column 
        :label="$t('msg.총수익')" prop="tt567" align="center">
         <template slot-scope="scope"> <span class="text-primary">{{ formatMoney(scope.row.tt567)}}</span></template>
      </el-table-column>

      <el-table-column 
        :label="$t('msg.총수익카')" prop="tt567ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567ca)}}</template>
      </el-table-column>
      <el-table-column 
        :label="$t('msg.총수익슬')" prop="tt567st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567st)}}</template>
      </el-table-column>
      <el-table-column 
        :label="$t('msg.총수익파')" v-if="this.power=='1'" prop="tt567pa" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567pa)}}</template>
      </el-table-column>


        
	
		 
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
				
				
</div>
 </template>

 <script>
 
    export default {
      
    	data(){
    		return{
    			domain:window.sessionStorage.getItem('domain'),
          rosing:window.sessionStorage.getItem('rosing'),
          power:window.sessionStorage.getItem('power'),
    			  qa:[],
    			   colorObj:{
			        '0':'text-danger',
			        '1':'text-primary',
			        '2':'text-success',
			       
			       
			      },
    			
    			searchform:{
    				  searchOptions:[
             
            {
              label:this.$i18n.t("msg.회원"),
              value:'mem_id'
            },
           
            {
              label:this.$i18n.t("msg.매장"),
              value:'c_code'
            },
            {
              label:this.$i18n.t("msg.총판"),
              value:'a_code'
            },
            {
              label:this.$i18n.t("msg.부본"),
              value:'b_code'
            }
            ,
            {
              label:this.$i18n.t("msg.본사"),
              value:'s_code'
            }
            ,
            {
              label:this.$i18n.t("msg.마스터"),
              value:'m_code'
            }
            ,
            {
              label:this.$i18n.t("msg.알본"),
              value:'admin_id'
            } 
            ],
           
            value:'',
    				time:[],
            keyword:'',
    			


    			},
    			 pickerOptions: {
    			},
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        

    			total:0,
    			size:0,
    			loading: false,
    			 editIndex:-1,
    			 creatModel:false,
    			 tableData: [],
    			
			          currentPage:1,
			          multipleSelection:[],
			       
			         
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
    	
    	methods:{
    	
    			 // 搜索事件
			searchEvent(){

    			this.getList();
    			
             

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			       getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if(index === 0){
             sums[index] = this.$i18n.t("msg.합계");
          }
         else if (index === 1) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 2) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 3) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 4) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 5) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 6) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 7) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 8) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 9) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 10) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 11) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 12) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 13) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 14) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 15) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 16) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 17) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 18) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 19) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            } else {
              sums[index] = '/';
            }
          }
        });
        return sums;
      },
    		getList(){

    		 
               console.log(this.searchform.time) 
         

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/calculation?s_time='+s_time+'&e_time='+e_time+'&page='+this.currentPage+'&'+this.searchform.value+'='+this.searchform.keyword;
    			
    
    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     console.log('data=',response.data.data)
                     this.tableData =response.data.data
                     this.total = response.data.total
                     this.currentPage = response.data.current_page
                     this.size =response.data.per_page
                     this.loading =false
               
            }).catch((error) =>{
            	

               this.$message.error(error);
               this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		
    		
    	
    	
    	
    		
    	}
  }
</script>

 <style scoped>
 .bg-danger{
 	background-color:#72e8ff!important
 }
.bg-primary{
	background-color:#acc4dd!important
}
.bg-yellow {
    background-color: #dc8e35!important;
}
/deep/ .el-select-dropdown__item.selected{
	color:#000
}
/deep/ .el-input__inner{
	background:transparent;
	border:1px solid #cfcfcf;
	border-radius:2px;
}
/deep/ .el-dialog__body{
	padding:10px 20px;
}
/deep/ .el-form-item {
	margin-bottom:10px;
}
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }


</style>


// WEBPACK FOOTER //
// src/views/calculation/list.vue